/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LookupSourceArtistResponseMembersInner
 */
export interface LookupSourceArtistResponseMembersInner {
    /**
     * 
     * @type {string}
     * @memberof LookupSourceArtistResponseMembersInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof LookupSourceArtistResponseMembersInner
     */
    stageName: string;
    /**
     * 
     * @type {boolean}
     * @memberof LookupSourceArtistResponseMembersInner
     */
    _exists: boolean;
    /**
     * 
     * @type {string}
     * @memberof LookupSourceArtistResponseMembersInner
     */
    internalId?: string | null;
}

/**
 * Check if a given object implements the LookupSourceArtistResponseMembersInner interface.
 */
export function instanceOfLookupSourceArtistResponseMembersInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "stageName" in value;
    isInstance = isInstance && "_exists" in value;

    return isInstance;
}

export function LookupSourceArtistResponseMembersInnerFromJSON(json: any): LookupSourceArtistResponseMembersInner {
    return LookupSourceArtistResponseMembersInnerFromJSONTyped(json, false);
}

export function LookupSourceArtistResponseMembersInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): LookupSourceArtistResponseMembersInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'stageName': json['stageName'],
        '_exists': json['exists'],
        'internalId': !exists(json, 'internalId') ? undefined : json['internalId'],
    };
}

export function LookupSourceArtistResponseMembersInnerToJSON(value?: LookupSourceArtistResponseMembersInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'stageName': value.stageName,
        'exists': value._exists,
        'internalId': value.internalId,
    };
}

